import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class PasswordResetFinishService {
  constructor(private http: HttpClient) {}

  save(keyAndPassword: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/updateForgotPassword`, keyAndPassword);
  }

  validateKey(key): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/verifyForgotPassword?forgotPasswordKey=${encodeURIComponent(key)}`, {});
  }
}
